import { Component } from '@angular/core';

@Component({
  selector: 'app-politicas-privacidad',
  templateUrl: './politicas-privacidad.component.html',
  styleUrls: ['../../../assets/css/footer-pages.css'],
})
export class PoliticasPrivacidadComponent {}
